/**
 * Default insurance coverage configuration
 */
const defaultInsuranceCoverage = {
  coverageItems: [],
  disclaimerText: '',
};

export default defaultInsuranceCoverage;
